import Aprillia from '$lib/images/brands/aprilia-logo-big.png';
import BMW from '$lib/images/brands/bmw-logo-big.png';
import Babetta from '$lib/images/brands/babetta-logo-big.png';
import China from '$lib/images/brands/china-logo-big.png';
import Honda from '$lib/images/brands/honda-logo-big.png';
import Kawasaki from '$lib/images/brands/kawasaki-logo-small.png';
import Suzuki from '$lib/images/brands/suzuki-logo-big.png';
import Yamaha from '$lib/images/brands/yamaha-logo-big.png';
import Cagiva from '$lib/images/brands/cagiva-logo-big.png';
import Cpi from '$lib/images/brands/cpi-logo-big.png';
import Derbi from '$lib/images/brands/derbi-logo-big.png';
import Daelim from '$lib/images/brands/daelim-logo-big.png';
import Eon from '$lib/images/brands/e.on-logo-big.png';
import Gilera from '$lib/images/brands/gilera-logo-big.png';
import Hyosung from '$lib/images/brands/hyosung-logo-big.png';
import Italjet from '$lib/images/brands/italjet-logo-big.png';
import Keeway from '$lib/images/brands/keeway-logo-big.png';
import Kymco from '$lib/images/brands/kymco-logo-big.png';
import Malaguti from '$lib/images/brands/malaguti-logo-big.png';
import Mbk from '$lib/images/brands/mbk-logo-big.png';
import Motorro from '$lib/images/brands/motorro-logo-big.png';
import Peugeot from '$lib/images/brands/peugeot-logo-big.png';
import Piaggio from '$lib/images/brands/piaggio-logo-big.png';
import Rhon from '$lib/images/brands/rhon-logo-big.png';
import Sym from '$lib/images/brands/sym-logo-big.png';
import TGB from '$lib/images/brands/tgb-logo-big.png';
import Yuki from '$lib/images/brands/yuki-logo-big.png';
import Benelli from '$lib/images/brands/benelli-logo-big.png';
import Beta from '$lib/images/brands/beta-logo-big.png';
import Kentoya from '$lib/images/brands/kentoya-logo-big.png';
import Kingway from '$lib/images/brands/kingway-logo-small.png';
import SuperSoco from '$lib/images/brands/supersoco-logo-small.png';
import Maxon from '$lib/images/brands/maxon-logo-big.png';


export const resolveImageByUrl = (brand: string) => {
    switch (brand) {
        case 'aprilia':
            return Aprillia;
        case 'bmw':
            return BMW;
        case 'honda':
            return Honda;
        case 'kawasaki':
            return Kawasaki;
        case 'suzuki':
            return Suzuki;
        case 'yamaha':
            return Yamaha;
        case 'cagiva':
            return Cagiva;
        case 'cpi':
            return Cpi;
        case 'derbi':
            return Derbi;
        case 'daelim':
            return Daelim;
        case 'e.on':
            return Eon;
        case 'gilera':
            return Gilera;
        case 'hyosung':
            return Hyosung;
        case 'italjet':
            return Italjet;
        case 'keeway':
            return Keeway;
        case 'kymco':
            return Kymco;
        case 'malaguti':
            return Malaguti;
        case 'mbk':
            return Mbk;
        case 'motorro':
            return Motorro;
        case 'peugeot':
            return Peugeot;
        case 'piaggio':
            return Piaggio;
        case 'rhon':
            return Rhon;
        case 'sym':
            return Sym;
        case 'tgb':
            return TGB;
        case 'yuki':
            return Yuki;
        case 'babetta':
            return Babetta;
        case 'eon':
            return Eon;
        case 'benelli':
            return Benelli;
        case 'beta':
            return Beta;
        case 'kentoya':
            return Kentoya;
        case 'kingway':
            return Kingway;
        case 'maxon':
            return Maxon;
        case 'super soco':
            return SuperSoco;
        case 'china':
            return China;
        default:
            return null;
    }
}

